/* eslint-disable no-restricted-syntax */
import { createApp } from 'vue';

import 'bootstrap/dist/js/bootstrap.bundle.min';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import axios from 'axios';

// VueAxios 的目的是讓 axios 被 Vue 整合(加在 Vue 原型中)，確保所有模組都可以使用 axios
import VueAxios from 'vue-axios';

import App from './App.vue';
import router from './router/index';
import { store } from './store';

import '@fortawesome/fontawesome-free/css/all.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'element-plus/dist/index.css';
import '@/style.css';

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(ElementPlus);
app.use(VueAxios, axios);
app.use(store);
app.use(router);

app.mount('#app');
